import { font } from 'modules/styles';
import styled from 'styled-components';

export const Root = styled.div`
    ${font(11, '#6c6a6a')}
    text-align: center;
`;

export const NoWrapLink = styled.a`
    white-space: nowrap;
`;
